<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 15:56:06
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card entrance-card" style="width: 3.54rem; padding: 0;">
    <div class="card-header business" style="font-size: 0.105rem;padding-bottom: 0.083rem;">
      <div>{{ $t('homePage.wdyy') }}</div>
      <!-- <div class="more">自定义排序</div> -->
    </div>
    <div class="card-contont entrance-scroll">
      <div class="links-box">
        <div class="links-items" v-for="(item, index) in appList" :key="item.appId"
          :title="item.isOpen === 0 ? '暂未开通此系统' : ''"
          :style="{ 'background': isActiveCell === `isActiveCell${index}` ? lightColor : 'transparent' }"
          @mouseover="handleMouseover($event, index)" @mouseleave="handleMouseleave($event, index)"
          @click="itemClick(item)">
          <div class="icon-wrapper">
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-if="item.appSign === 'auth-sso'"
              :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-6`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`"
              v-else-if="['auth-sap-bw'].includes(item.appSign)" :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-2`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-oa'"
              :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-3`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-crm'"
              :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-4`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-reim'"
              :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-5`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-sap-po'"
              :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-sap`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`"
              v-else-if="item.appSign === 'auth-api-gateway'" :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-api`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`"
              v-else-if="['auth-rets-fh'].includes(item.appSign)" :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-zhuisu`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`"
              v-else-if="['auth-retsyh'].includes(item.appSign)" :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-zhuisu`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else :disabled="item.isOpen === 0">
              <svg v-if="item.logoUrl == null" class="icon" aria-hidden="true">
                <use :xlink:href="`#icon-star${appIconList[(index + 1) % 9]}`"></use>
              </svg>
              <img v-else :class="`circle circle-${appColorList[(index + 1) % 9]}`" :src="item.logoUrl" />
            </span>
            <Badge v-if="item.appSign === 'auth-mail' && item.newMailCount && item.newMailCount > 0"
              class-name="box-background" :count="item.newMailCount"
              style="position: absolute; top: -2px; right: -2px;"></Badge>
          </div>
          <div class="app-name">{{ item.appName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cookie } from '@/libs/location'

export default {
  components: {},
  data() {
    return {
      // 应用列表
      appList: [],
      appColorList: ['yellow', 'cyan', 'blue', 'green', 'orange', 'red', 'color1', 'color2', 'color3'],
      appIconList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      isActiveCell: 'isActiveCell',
      lightColor: '',
      primaryColor: ''
    }
  },
  computed: {},
  created() {
    this.doGetUserInfo()
    // 如果用户信息获取失败，也尝试获取应用列表
    this.doGetAppList()
  },
  methods: {
    // 获取用户信息（用于获取主题色）
    doGetUserInfo() {
      this.$request.post('/sso/userAttr/findUserInfo').then(res => {
        const { code, data } = res.data
        if (code === 'OK' && data && data.skinColor) {
          let _color = this.handleTurnColorRgb(data.skinColor)
          this.lightColor = `rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, .2)`
          this.primaryColor = `rgb(${_color[0]}, ${_color[1]}, ${_color[2]})`
        }
      }).catch(() => {
        // 如果获取用户信息失败，使用默认颜色
        this.lightColor = 'rgba(0, 168, 254, .2)'
        this.primaryColor = 'rgb(0, 168, 254)'
      })
    },
    // 16进制颜色值换算成rgb值
    handleTurnColorRgb(colorStr) {
      // 16进制颜色值的正则
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 把颜色值变成小写
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return [0, 168, 254] // 默认颜色
      }
    },
    // 获取应用列表
    doGetAppList() {
      this.$request.post('/sso/app/getUserAppPage').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          if (data.length > 0) {
            let _copyData = JSON.parse(JSON.stringify(data))
            _copyData.forEach(n => {
              if (n.appSign === 'auth-mail' && n.isOpen === 1) {
                this.doGetEmailCount(n.appCount).then(k => {
                  n.newMailCount = k
                })
              } else {
                n.newMailCount = 0
              }
            })
            this.appList = _copyData
          }
        }
      })
    },
    // 查询用户未读邮件个数
    doGetEmailCount(userAccount) {
      return this.$request.get(`/sso/mailNetease/getNewEmailCount/${userAccount}`).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          return data
        }
      })
    },
    // 鼠标悬停
    handleMouseover(e, index) {
      this.isActiveCell = `isActiveCell${index}`
    },
    // 鼠标离开
    handleMouseleave(e, index) {
      this.isActiveCell = 'isActiveCell'
    },
    // 我的应用列表跳转
    itemClick(item) {
      if (item.isOpen === 0) {
        return false
      }
      if (item.appSign) {
        let _token = cookie.getCookie('token')
        this.$request.post('/sso/sync/loginOutInfo').then(res => {
          let { code } = res.data
          if (code === 'OK') {
            window.open(`${this.$baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${_token}`, `sso${item.appSign}`)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.entrance-card {
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.entrance-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto !important;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
}

.entrance-scroll .links-box {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

/* 每排 5 个，略放大图标，减少「一排 4 个」两侧留空 */
.links-items {
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  flex: 0 0 20%;
  width: 20%;
  max-width: 20%;
  box-sizing: border-box;
  padding: 12px 6px;

  .icon-wrapper {
    position: relative;
    display: inline-block;

    .circle {
      display: inline-block;
      width: 60px;
      height: 60px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;

      &[disabled] {
        background: #ddd;
      }

      &-yellow {
        background: linear-gradient(136deg, #FFD84F 0%, #FE9B4C 100%);
      }

      &-cyan {
        background: linear-gradient(136deg, #14D6D6 0%, #14BAB7 100%);
      }

      &-blue {
        background: linear-gradient(136deg, #42ACFF 0%, #0792FF 100%);
      }

      &-green {
        background: linear-gradient(136deg, #2AE098 0%, #13BA7B 100%);
      }

      &-orange {
        background: linear-gradient(136deg, #FD8541 0%, #FD7021 100%);
      }

      &-red {
        background: linear-gradient(136deg, #FE7373 0%, #E23130 100%);
      }

      &-color1 {
        background: linear-gradient(136deg, #E57FD2 0%, #E694D7 100%);
      }

      &-color2 {
        background: linear-gradient(136deg, #8BE6DB 0%, #99E5DC 100%);
      }

      &-color3 {
        background: linear-gradient(136deg, #E28694 0%, #E297A2 100%);
      }

      img {
        width: 100%;
        height: 100%;
        margin-bottom: 0 !important;
        // border-radius: 50%;
      }

      .icon {
        width: 32px;
        height: 32px;
        color: #FFFFFF;
      }
    }
  }

      .app-name {
    margin-top: 10px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1.4;
    height: 2.8em;
    min-width: 0;
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
  }
}
</style>
